import { MyChartOpenSchedulingConfig } from '@kyruus/types';
import { ValidationIssue } from '../../types';

export function validateMyChartOpenSchedulingConfiguration(
  config?: MyChartOpenSchedulingConfig | null,
  issues?: ValidationIssue[]
): config is Required<MyChartOpenSchedulingConfig> {
  if (!issues) {
    issues = [];
  }

  if (!config) {
    issues.push({
      name: 'config.third_party.mychart_open_scheduling',
      message: '"mychart_open_scheduling" configuration is missing.'
    });
    return false;
  }

  if (!config.url) {
    issues.push({
      name: 'config.third_party.mychart_open_scheduling.url',
      message: '"url" is required.'
    });

    return false;
  }

  return true;
}
